export default "__VITE_ASSET__DFbONDAi__"